import { Card, Col, Popover, Row, Tabs } from "antd";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DiscordChannelDetail from "../ChannelDetail/DiscordChannelDetail";
// eslint-disable-next-line import/extensions
import RetentionChart from "../Charts/RetentionChart";
// eslint-disable-next-line import/extensions
import { ChannelSelector } from "../common";
import DiscordActiveMembersCard from "../DiscordActiveMembersCard/DiscordActiveMembersCard";
import NewMembersCard from "../NewMembersCard/NewMembersCard";
import TopPosts from "./TopPosts";
import { useLocation } from "react-router-dom";
import ActiveTimeCard from "../ActiveTimeCard/ActiveTimeCard";
import DateRangePicker from "../DateRangePicker/DateRangePicker";
import { useDiscordChannelsContext } from "../ChannelContext/ChannelContext";
import { RolePicker } from "../Charts/RolePicker";
import { InfoCircleOutlined } from "@ant-design/icons";
const { TabPane } = Tabs;

// insights page for discord
const DiscordInsightsPage = () => {
  const location = useLocation();
  const channel = new URLSearchParams(location.search).get("channel");
  // Card expansion triggers
  const [expandActiveMembers, setExpandActiveMembers] =
    useState<boolean>(false);
  const [expandNewMembers, setExpandNewMembers] = useState<boolean>(false);
  const [expandActiveTime, setExpandActiveTime] = useState<boolean>(false);
  const [roleIdSelected, setRoleIdSelected] = useState<string | null>(null);
  const navigate = useNavigate();
  const guildId = localStorage.getItem("guild-id");

  const { selectedChannel } = useDiscordChannelsContext();

  return (
    <div>
      <Tabs
        onChange={(activeKey) => {
          if (activeKey !== "2") navigate("/insights");
          if (activeKey === "2")
            navigate(`/insights?channel=${selectedChannel?.discord_id}`);
        }}
        defaultActiveKey={channel ? "2" : "1"}
        tabBarExtraContent={
          <DateRangePicker
            customOption={{ disabled: false }}
            rangeOfSelector={{
              range: "day",
              selectorDefaultOptions: [
                { value: 7, disabled: false },
                {
                  value: 30,
                  disabled: false,
                },
              ],
            }}
          />
        }
      >
        <TabPane tab="Overview" key="1" style={{ padding: 20 }}>
          <Row gutter={[32, 32]} style={{ marginBottom: 50 }}>
            <Col lg={24}>
              <Card
                title={
                  <div className="flex gap-x-1 items-center">
                    <p className="inline ml-2 mb-0">
                      Member retention over last 6 months
                    </p>
                    <Popover
                      content={
                        <p className="m-0 w-96">
                          The chart shows % of members that are active in a
                          given month based on a cohort of the month they
                          joined. Active means they either posted a message, or
                          left a reaction in that month.
                        </p>
                      }
                      placement="bottomLeft"
                    >
                      <div className="h-7">
                        <InfoCircleOutlined />
                      </div>
                    </Popover>
                  </div>
                }
                extra={<RolePicker roleCallback={setRoleIdSelected} />}
              >
                <RetentionChart interval="6" roleId={roleIdSelected} />
              </Card>
            </Col>
            <Col lg={12}>
              <DiscordActiveMembersCard
                guildId={guildId}
                span={24}
                expandActiveMembers={expandActiveMembers}
                setExpandActiveMembers={setExpandActiveMembers}
              />
            </Col>
            <Col lg={expandNewMembers ? 24 : 12} md={24}>
              <NewMembersCard
                span={12}
                expandNewMembers={expandNewMembers}
                setExpandNewMembers={setExpandNewMembers}
              />
            </Col>
            <Col lg={expandActiveTime ? 24 : 12} md={24}>
              <ActiveTimeCard
                expandActiveTime={expandActiveTime}
                setExpandActiveTime={setExpandActiveTime}
              />
            </Col>
            <Col span={12}>
              <TopPosts platform="discord" />
            </Col>
          </Row>
        </TabPane>
        <TabPane tab="Channels" key="2" style={{ paddingTop: 20 }}>
          <ChannelSelector platform="discord" />
          <DiscordChannelDetail />
        </TabPane>
      </Tabs>
    </div>
  );
};

export default DiscordInsightsPage;
